import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { DisplayBannerDto } from "../models/display-banner-dto";

@Injectable()
export class DiscontinuedProductsService {
  private _discontinuedProductsApiUrl: string = `${environment.api}/discontinued-products`;
  constructor(private http: HttpClient) {}

  getItemDispositionNeededBanner() {
    return this.http.get<DisplayBannerDto>(
      `${this._discontinuedProductsApiUrl}/supplier/banner`,
    );
  }
}
